import XMLField from './XMLField';

export default XMLField;
